/**
 * Finland crypto-tax page: clear namespaced keys on load so ledger data comes from imported files.
 * Filing basis (FIFO vs deemed vs `best`) is controlled only by `taxPipelineConfig.fi.basisMethod`.
 */

/** Namespace for this helper — safe to clear without touching other app modules (e.g. Travel Buddy). */
export const FI_TAX_LOCAL_STORAGE_PREFIX = 'sisuforge.fi.';

/** Remove all `sisuforge.fi.*` keys (reserved for future UI prefs). */
export function clearFiTaxLocalStorage(): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    const toRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(FI_TAX_LOCAL_STORAGE_PREFIX)) toRemove.push(k);
    }
    for (const k of toRemove) window.localStorage.removeItem(k);
  } catch {
    /* quota / private mode */
  }
}
